// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"ScreenReaderOnlyText_srOnly__ykZhN"};